import { ShieldOff } from 'lucide-react';
import { Link } from 'react-router-dom';

import { ROTAS } from '@/shared/lib/rotas';
import { Button } from '@/shared/ui/button';

/** Não existe na V1 — lá o usuário sem acesso era redirecionado sem explicação. */
export function Erro403Page() {
  return (
    <div className="flex flex-col items-center justify-center gap-4 py-20 text-center">
      <ShieldOff className="w-16 h-16 text-brand/40" />
      <div className="space-y-1">
        <h1 className="text-2xl font-bold text-foreground">Acesso negado</h1>
        <p className="text-sm text-muted-foreground max-w-md">
          Seu cargo não tem permissão para esta tela. Se você precisa dela, peça ao administrador
          para incluir a permissão no seu cargo.
        </p>
      </div>
      <Button asChild variant="outline">
        <Link to={ROTAS.dashboard}>Voltar ao dashboard</Link>
      </Button>
    </div>
  );
}
